import { createReducer, on } from '@ngrx/store';
import { IPrograma } from 'src/app/interfaces/programas.insterface';
import { GetProgramasSuccess } from '../actions/programas.actions';


export interface IProgramasState {
  programas: IPrograma[];
}

export const initialProgramasState: IProgramasState = {
  programas: []
};

export const programasReducers = createReducer(
    initialProgramasState,
  on(GetProgramasSuccess, (state, { programas }) => {
    return {
        ...state,
        programas
    };
  })
);
